import { createAction } from 'redux-actions';

export const toggleElementVisibility = createAction('General/TOGGLE_ELEMENTVISIBILITY');
export const setLinkedWellboreId = createAction('General/SET_LINKEDWELLBOREID');
export const setRankingType = createAction('General/SET_RANKINGTYPE');
export const setSelectedResultGroup = createAction('General/SET_SELECTEDRESULTGROUP');
